import model from './model';

const actions = {
  assignFormData: model.assign<'SUBMIT'>({
    formData: (context, event) => event.values,
  }),
};

export default actions;
